export type DeferredAnswerResolutionRef<T> = {
    current: Promise<T> | null
}

export async function resolveDeferredAnswerForPress<T>(
    resolutionRef: DeferredAnswerResolutionRef<T>,
    resolveAnswer: () => Promise<T>,
): Promise<T> {
    let pendingResolution = resolutionRef.current
    if (!pendingResolution) {
        pendingResolution = resolveAnswer()
        resolutionRef.current = pendingResolution
    }

    try {
        return await pendingResolution
    } finally {
        if (resolutionRef.current === pendingResolution) {
            resolutionRef.current = null
        }
    }
}
